import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AppleDeviceEffects } from './apple-device.effects';
import { appleDeviceReducer } from './apple-device.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('apple-devices', appleDeviceReducer),
    EffectsModule.forFeature([AppleDeviceEffects]),
  ],
  providers: [],
})
export class AppleDeviceStoreModule {}
